import { Avatar, Box, Card, Grid, Rating, Typography } from "@mui/material";
import React from "react";
import { styles } from "../styles/styles";
import { reviews } from "./data";
import { DecorativeCorner } from "../common/DecorativeCorner";
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";

function ReviewsSection() {
  return (

    <Card
      sx={{
        ...styles.whyuse,
        height: { xs: "auto", sm: 615 },
        padding: { xs: 2, sm: 4 },

      }}
    >
      <DecorativeCorner sx={{ top: -20, left: -20, transform: "rotate(0deg)" }} />
      <DecorativeCorner sx={{ top: -20, right: -20, transform: "rotate(0deg)" }} />
      <DecorativeCorner sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }} />
      <DecorativeCorner sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }} />

      <Typography variant="h4" component="h1" sx={{ ...styles.heading }}>
        Our Reviews
      </Typography>

      <Grid container spacing={3} justifyContent="center">
        {reviews.map((review) => (
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            key={review.id}
            sx={{ display: "flex", justifyContent: "center" }}
          >
            <Card
              sx={{
                ...styles.reviewCard,
                p: { xs: 1.5, sm: 3 },
                mb: { xs: 2, sm: 0 },
                width: { xs: "90%", sm: "100%" },
                maxWidth: { xs: "280px", sm: "100%" },
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
              }}
            >
              <FormatQuoteIcon sx={{ ...styles.quoteIcon, fontSize: { xs: "1.5rem", sm: "2.5rem" } }} />

              <Typography
                variant="body2"
                sx={{ ...styles.reviewText, fontSize: { xs: "0.75rem", sm: "1rem" } }}
              >
                {review.review}
              </Typography>

              <Box sx={{ ...styles.reviewerInfo, flexDirection: { xs: "column", sm: "row" }, alignItems: "center" }}>
                <Box sx={styles.reviewerDetails}>
                  <Typography
                    variant="subtitle2"
                    sx={{ ...styles.reviewerName, fontSize: { xs: "0.875rem", sm: "1rem" }, textAlign: { xs: "center", sm: "left" } }}
                  >
                    {review.name}
                  </Typography>

                  <Typography
                    variant="body2"
                    sx={{ ...styles.reviewerRole, fontSize: { xs: "0.75rem", sm: "0.875rem" }, textAlign: { xs: "center", sm: "left" } }}
                  >
                    {review.role}
                  </Typography>
                  <Box sx={{ ml: { xs: 0, sm: "auto" }, mt: { xs: 1, sm: 0 } }}>
                    <Rating value={review.rating} readOnly size="small" sx={{ color: "black" }} />
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: { xs: "55px", sm: "65px" },
                    height: { xs: "55px", sm: "65px" },
                    borderRadius: "50%",
                    border: "3px solid black",
                    padding: "3px",
                  }}
                >
                  <Avatar
                    src={review.avatar}
                    alt={review.name}
                    sx={{
                      height: { xs: "35px", sm: "45px" },
                      width: { xs: "35px", sm: "45px" },
                      borderRadius: "50%",
                    }}
                  />
                </Box>

              </Box>
            </Card>
          </Grid>
        ))}
      </Grid>

    </Card>


  );
}

export default ReviewsSection;